import { StateAbbreviation } from '@/store/pinia/physician'
import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type State = ApiSchemas['StatePresenter']

export default {
  async get(id: StateAbbreviation) {
    return wrapEndpoint(() => client.GET('/state/{id}', { params: { path: { id } } }))
  },

  async list(options?: ApiSchemas['ListStateDto']) {
    return wrapEndpoint(() =>
      client.GET('/state', {
        params: {
          query: options,
        },
      }),
    )
  },
}
